import './styles.scss';

export { default as Footer } from './Footer';
